export default __webpack_public_path__ + "static/media/ecosystem.4dd014eb.png";